<template>
  <v-card flat>
    <div class="hyp-risk-content-container">
      <v-select
        v-if="subRiskTypes && subRiskTypes.length > 0"
        v-model="selectedSubRiskType"
        :items="subRiskTypes"
        item-text="name"
        item-value="name"
        :label="title"
        class="pt-1 my-0 hyp-risk-content-select"
        clearable
        :menu-props="{ contentClass: 'hyp-risk-content-select-item' }"
      >
      </v-select>
      <div
        v-if="!subRiskTypes || subRiskTypes.length < 1"
        class="details-heading application-heading mb-4"
      >
        {{ title }}
      </div>
      <v-row v-if="riskBody">
        <v-col cols="12" class="pt-0 content-container">
          <v-card
            flat
            outlined
            color="transparent"
            ref="risksContentBody"
            v-html="riskBody"
            class="mt-0 pt-0"
          >
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import lodashGet from "lodash/get";
import lodashRemove from "lodash/remove";
import lodashDebounce from "lodash/debounce";
import lodashMethod from "lodash/method";
import lodashMap from "lodash/map";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashFind from "lodash/find";

import { hasGrdAccess } from "@/services/user/user.service";

import { getRiskRatingCategories } from "@/services/controlRisks/risks.service";

import { RISK_RATING_PRIMARIES } from "@/common/constants/controlRisks/risks";

import {
  addCardMoreLess,
  cleanUpAddCardMoreLessEvents,
} from "@/common/basic.utilities";

export default {
  name: "RisksContentBody",
  components: {},
  props: {
    title: {
      type: String,
    },
    body: {
      type: String,
    },
    publishDate: {
      type: String,
    },
    riskContent: {
      type: Array,
      required: true,
    },
    selectedPrimaryRiskCategory: {
      type: Object,
      required: false,
    },
    risksContentExpanded: {
      type: String,
      required: false,
    },
    mainOverview: {
      type: Object,
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      subRiskTypes: null,
      selectedSubRiskType: null,
      riskBody: null,
    };
  },
  methods: {
    async getFilteredSubRiskTypes() {
      let riskRatingCategories = await getRiskRatingCategories();
      lodashRemove(riskRatingCategories, (r) => {
        let hasRating = false;
        for (let i = 0; i < this.riskContent.length; i++) {
          if (lodashFind(this.riskContent[i].risks, ["id", r.id])) {
            hasRating = true;
            break;
          }
        }
        return (
          r.parentId !== this.selectedPrimaryRiskCategory.riskCategoryId ||
          !hasRating
        );
      });
      return riskRatingCategories;
    },
  },
  watch: {
    risksContentExpanded: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && this.$refs["risksContentBody"]) {
          if (this.risksContentExpanded) {
            const showMore = this.$refs["risksContentBody"].$el.querySelector(
              ".show-more"
            );
            if (showMore) {
              showMore.click();
            }
          } else {
            const showLess = this.$refs["risksContentBody"].$el.querySelector(
              ".show-less"
            );
            if (showLess) {
              showLess.click();
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
    body: {
      handler() {
        this.riskBody = lodashCloneDeep(this.body);
      },
      immediate: true,
    },
    riskBody: {
      handler() {
        addCardMoreLess(this.$refs, "risksContentBody");
      },
      immediate: true,
    },
    selectedPrimaryRiskCategory: {
      async handler() {
        if (this.selectedPrimaryRiskCategory) {
          this.subRiskTypes = await this.getFilteredSubRiskTypes();
          if (
            this.selectedPrimaryRiskCategory.riskCategoryId !==
              RISK_RATING_PRIMARIES.cyber &&
            !hasGrdAccess()
          ) {
            this.subRiskTypes.unshift({
              name: "Overview",
            });
          }
        }
      },
      immediate: true,
    },
    selectedSubRiskType: lodashDebounce(function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.selectedSubRiskType) {
          if (
            this.selectedSubRiskType === "Overview" &&
            lodashGet(this.mainOverview, "body")
          ) {
            this.riskBody = this.mainOverview.body;
          } else {
            this.riskContent.forEach((item) => {
              if (item.riskTypes) {
                const categories = lodashMap(
                  item.riskTypes,
                  lodashMethod("toLowerCase")
                );
                if (
                  categories.length > 1 &&
                  categories.includes(this.selectedSubRiskType.toLowerCase())
                ) {
                  this.riskTitle = item.title;
                  this.riskPublishDate = item.publishDate;
                  let body = item.body;
                  if (body === `<p style="background: white;">&nbsp;</p>`) {
                    body = this.body;
                  }
                  this.riskBody = body;
                }
              }
            });
          }
        } else {
          this.riskBody = lodashCloneDeep(this.body);
        }
      }
    }, 500),
  },
  beforeDestroy() {
    cleanUpAddCardMoreLessEvents();
  },
};
</script>

<style scoped>
.details-heading {
  font-size: 20px;
}
.content-container {
  max-width: 550px !important;
  font-size: 14px;
}
.hyp-risk-grid .content-container {
  max-width: unset !important;
}
.hyp-risks-content-expanded .hyp-risk-content-container {
  max-width: 50vw;
  margin: 12px auto;
}
</style>

<style>
.hyp-risk-content-select .v-select__selection,
.hyp-risk-content-select-item .v-list-item .v-list-item__title {
  text-transform: capitalize !important;
}
</style>
